import { Box, TextField, Typography } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Send, PhoneAndroid } from "@mui/icons-material";
import React, { useState } from "react";

import TextArea from "../TextArea";
import "./contact.css";

export default function Contact() {
  const [subject, setSubject] = useState();
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const isMobile = window.innerWidth <= 768;

  return (
    <section id="contact">
      <Typography variant="h4" className="contact-title">
        Get In
      </Typography>

      <Box className="mobile_contact contact-container">
        <Box className="left">
          <Typography variant="h5" className="title" id={!isMobile ? "fromRight" : ""}>
            Let's Connect
          </Typography>
          <Typography variant="body1" className="cta" id={!isMobile ? "fromLeft" : ""}>
            I'm always interested in discussing new opportunities, backend engineering
            challenges, and full stack projects. Whether you're hiring, collaborating,
            or simply want to connect, I'd be happy to hear from you.
          </Typography>
          <Box className="flex gap-2" id={!isMobile ? "fromRight" : ""}>
            <Send className="text-[#0ef]" />
            <Typography
              component={"a"}
              href="mailto:ghulamullahkhan84@gmail.com"
              variant="body1"
              className="text-[#0ef]"
            >
              ghulamullah232@gmail.com
            </Typography>
          </Box>
          <Box className="flex gap-2" id={!isMobile ? "fromRight" : ""}>
            <PhoneAndroid className="text-[#0ef]" />
            {/* <box-icon name="phone" type="solid" color="#0ef"></box-icon> */}
            <Typography
              variant="body1"
              component={"a"}
              href="tel:+923096126978"
              className="text-[#0ef]"
            >
              0309-6126978
            </Typography>
          </Box>
          <Box className="icon-container">
            <Box
              component={"a"}
              href="https://www.facebook.com/ghulamullah123"
              className="no-underline"
            >
              <FacebookIcon className="icon" id="list" style={{ "--i": 1 }} />
            </Box>
            <Box
              component={"a"}
              href="https://www.instagram.com/ghulamullah200/"
              className="no-underline"
            >
              <InstagramIcon className="icon" id="list" style={{ "--i": 2 }} />
            </Box>
            <Box
              component={"a"}
              href="https://www.linkedin.com/in/ghulam-ullah-695188175/"
              className="no-underline"
            >
              <LinkedInIcon className="icon" id="list" style={{ "--i": 3 }} />
            </Box>
            <Box
              component={"a"}
              href="https://api.whatsapp.com/send/?phone=923096126978&text&type=phone_number&app_absent=0"
              className="no-underline"
            >
              <WhatsAppIcon className="icon" id="list" style={{ "--i": 4 }} />
            </Box>
          </Box>
        </Box>

        <Box className="right" id={!isMobile ? "fromRight" : ""}>
          <TextField
            className="text-field"
            type="text"
            placeholder="Enter Your Name"
            size="md"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            className="text-field"
            type="email"
            placeholder="Enter Email"
            size="md"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            className="text-field"
            type="text"
            placeholder="Subject"
            size="md"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <TextArea
            email={email}
            name={name}
            subject={subject}
            setName={setName}
            setEmail={setEmail}
            setSubject={setSubject}
          />
        </Box>
      </Box>

      <Typography variant="body1" className="footer" id={!isMobile ? "fromBottom" : ""}>
        © {new Date().getFullYear()} Ghulam Ullah. All rights reserved.
      </Typography>
    </section>
  );
}
